import initialState from './initialState';
import * as types from './actionTypes';

export default (state = initialState, action) => {
  switch (action.type) {
    case types.EMAIL_VALIDATION:
      return {
        ...state,
        validateEmail: action.payload
      };
    default:
      return state;
  }
};
